var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerVariation3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24V11.07a13.05 13.05 0 004.18.73c6.73 1.23 13.73-3.44 20-4.86 6-.67 12.42 1 18.55.23 2.19-.46.73.23 4.37-.92 5.21-.52 10.93.79 16 .69 7.06-.71 13.68 1.89 21.1 1.16a27 27 0 016.55-.47c9.13-2.17 18.77 1.09 28 .46l3.27.23c3.13-.57 7.81.59 11.09.93a3.68 3.68 0 011.46.46c4.23.63 4 2.51 8 3 3.74.81 7 4.19 11.09 2.78a35.76 35.76 0 0113.28-5.1c2 0 4.67.16 6.55-.46 7.9-3.53 14.09-5.94 22.73-6.25l6.72.23c2.15.12 7.91 1.13 9.46-.46C214.41.11 220 .54 223.51 0l3.09.46c2 .47 3.09 1.86 4.73 2.78l5.45 2.09c3.55.42 5.16 3.63 7.64 5.32 2.2 1.88 4.93.66 7.46.46 3.45-.46 5.82.69 8.91 1.62.86.25 11.61 1.83 12.18 2.32 1.28.23 3.64-.69 6.19.46a33.38 33.38 0 008.36 2.09c6.38 0 10.32 6.57 16.55 3 1.82-.93 8.19 0 11.28-.69 1.83-.22 3.23-.5 4.91-.7 2 0 7.45.46 9.27 1.39.91.46 1.46 1.16 2.55 1.16 5.51.72 10.68-1.79 16.19-1.39l3.27-.24c3.45-.69 5.45 1.62 8.54 1.86 5.16 0 9.84.79 14.92.92V24z",
    fillRule: "evenodd",
    "data-name": "Layer 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerVariation3);
export default __webpack_public_path__ + "static/media/dividerVariation3.59110d739c2d212043538e6f81fdb78f.svg";
export { ForwardRef as ReactComponent };